import {event} from '../modules/event';
import {ajax} from '../modules/ajax';

class SearchPopup {
	constructor(wrapper){
		this._createElements(wrapper);
        this._initField();
		this._addEvents();
	}

	_createElements(wrapper){
        var self = this;

        this.wrapper = wrapper.querySelector('[data-SearchPopup-form]');
        this.field = this.wrapper.querySelector('[data-SearchPopup-field]');
        this.resultBox = wrapper.querySelector('[data-SearchPopup-box]');
		this.isSending = false;
		this.ajaxPath = this._defineAjaxPath();
        this.xmlhttp = false;
        this._returnCircuit = function(e){
            self._return.call(self, e);
        };
	}

    _initField(){
        this.field.focus();
    }

    _defineAjaxPath(){
        var part = (window.location + '').indexOf('/build/') === -1 ? '' : 'layouts',
            ajaxPath = part + '/search/fasthtml';

        return ajaxPath;
    }

	_addEvents(){
		var self = this;

        event.add(this.field, 'click', function(e){
            e.stopPropagation();
        });

		event.add(this.field, 'keyup', function(e){
			self._search.call(self);
		});
	}

    _search(){
        var self = this;
        if(this.xmlhttp) this.xmlhttp.abort();

        this.xmlhttp = ajax({
            data:{"query": this.field.value},
            url:this.ajaxPath,
            callback: function(msg){
                self._addResult.call(self, msg);
            }
        });
    }

    _addResult(msg){
        var self = this,
            msg = JSON.parse(msg);

        this.resultBox.innerHTML = msg.content ? msg.content : '';
    }

    del(){
        if(this.xmlhttp) {
            this.xmlhttp.abort();
            this.xmlhttp = false;
        }
    }
};

export {SearchPopup};